import { restApi } from '../../services/api';

export const uploadContractLayout = async (data: File[]) => {
  const formData = new FormData();
  data.forEach((d: File) => formData.append(`file`, d));
  return restApi.post<void, { message: string }>(
    `brands/general-settings/upload-contract`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

export const getBrandContract = async () =>
  restApi.get<any>(`brands/general-settings/has-contract`);

export const deleteContract = async () =>
  restApi.patch<any>(`brands/general-settings/delete-contract`);
